import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import actions from "./actions";

export function* createOrUpdateClassification() {
  yield takeEvery(
    actions.CREATE_OR_UPDATE_CLASSIFICATION_REQUESTED,
    function* (action) {
      try {
        const classification = yield call(
          actions.createOrUpdateClassification,
          action.payload
        );
        yield put({
          type: actions.CREATE_OR_UPDATE_CLASSIFICATION_SUCCEEDED,
          classification,
        });
      } catch (error) {
        yield put({
          type: actions.CREATE_OR_UPDATE_CLASSIFICATION_FAILED,
          error: error.response.data,
        });
      }
    }
  );
}
export default function* rootSaga() {
  yield all([fork(createOrUpdateClassification)]);
}
